import type { PrivateEventDetail } from '../../api/privateEvents';
import { EditSection } from '../shared/EditSection';

import { useWhenWhatForm } from './use-when-what-form';
import WhenWhatForm from './WhenWhatForm';
import WhenWhatView from './WhenWhatView';

/** When & what for a viewer who may edit. Its form state (and the venue,
 *  region and type lookups behind it) exists only for them. */
export default function WhenWhatEditable({
  event,
  frozen,
  onDenied,
}: {
  event: PrivateEventDetail;
  frozen: boolean;
  onDenied: () => void;
}) {
  const form = useWhenWhatForm(event, onDenied);
  return (
    <EditSection
      first
      frozen={frozen}
      title="When & what"
      editLabel="Edit When & what"
      onEdit={form.begin}
      onCancel={form.begin}
      onSave={form.submit}
      view={<WhenWhatView event={event} />}
      form={<WhenWhatForm form={form} />}
    />
  );
}
